// src/pages/About.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { motion } from 'framer-motion';
import 'swiper/css';
import 'swiper/css/autoplay';

// === ALL IMAGES ===
import heroBg from '../assets/Sonic/69.jpeg';

import slide1 from '../assets/pick2/sigiriya/pexels-nasti-362148574-18619138.jpg';
import slide2 from '../assets/pick2/yala/LK710A2062-02-E.webp';
import slide3 from '../assets/pick2/Nuware Eliya/istockphoto-579253918-612x612.jpg';
import slide4 from '../assets/pick2/sea/download (2).jpeg';
import slide5 from '../assets/pick2/Anuradapura/istockphoto-1255135539-612x612.jpg';

import tourImage1 from '../assets/pick2/Anuradapura/istockphoto-471199868-612x612.jpg';
import tourImage2 from '../assets/pick2/Anuradapura/istockphoto-824016044-612x612.jpg';

import tourImage4 from '../assets/pick2/yala/LK710A2062-02-E.webp';
import tourImage5 from '../assets/pick2/yala/istockphoto-1150626798-612x612.jpg';
import tourImage6 from '../assets/pick/23.jpeg';

import aboutImage from '../assets/Sonic/60.jpeg';
import offer1 from '../assets/Sonic/34.jpeg';
import offer2 from '../assets/Sonic/16.jpeg';
import offer3 from '../assets/Sonic/2.png';
import offer4 from '../assets/Sonic/50.jpeg';


import tourExpert from '../assets/Sonic/27.jpeg';
import villageImage from '../assets/Sonic/54.jpeg';

import arrow from '../assets/Navbar/logo.jpg';
import van from '../assets/pick/30.jpg';
import minibus from '../assets/pick/31.jpg';
import luxury from '../assets/pick/32.webp';
import car from '../assets/Aamy/31.jpeg';


import noticeFruits from '../assets/Sonic/GBLK717.webp';
import noticeFood from '../assets/Sonic/73.jpeg';
import noticeMassage from '../assets/Sonic/getlstd-property-photo.jpg';
import noticeFlowers from '../assets/Sonic/SFFB25C0008_1880x.webp';


// === ANIMATION VARIANTS ===
const sectionVariants = {
    hidden: { opacity: 0, y: 50, scale: 0.95 },
    visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.8, ease: 'easeOut' } },
};

const About = () => {
    const { t } = useTranslation('about');


    return (
        <div className="bg-[#001F3F] text-white">
            {/* ===== HERO SECTION ===== */}
            <motion.section
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={sectionVariants}
                className="relative max-h-[1400px] w-full bg-cover bg-center md:h-screen md:max-h-[740px] lg:max-h-[850px] xl:max-h-[1000px]"
                style={{
                    backgroundImage: `linear-gradient(0deg, rgba(0,0,0,0.7) 32.63%, rgba(0,0,0,0.2) 63.34%), url(${heroBg})`,
                }}
            >
                <div className="container mx-auto px-4">
                    <div className="relative w-full">
                        <div className="relative w-fit pt-[120px] md:pt-[100px] lg:pt-[120px] xl:pt-[150px]">
                            <h1 className="font-bold leading-[70px] md:leading-[47px] lg:leading-[5.5rem]">
                                <span
                                    className="text-[3.125rem] md:text-5xl lg:text-7xl xl:text-[6.25rem] text-[#7FDBFF]"

                                >
                                    {t('hero.discover')}
                                </span>
                                <br />
                                <span
                                    className="text-[4rem] md:text-[68px] lg:text-9xl xl:text-[9.375rem] text-[#0074D9]"

                                >
                                    {t('hero.starLankaTours')}
                                </span>
                            </h1>
                            <div className="absolute right-2 top-[180px] h-[5px] w-[100px] bg-white md:top-[125px] md:h-[4px] md:w-[105px] lg:top-[200px] lg:h-[5px] lg:w-[245px] xl:top-[230px]"></div>
                            <div className="absolute h-[5px] w-[110px] bg-white md:h-[4px] lg:h-[5px] lg:w-[230px] bottom-[-20px] left-0"></div>
                        </div>

                        <div className="flex w-full flex-col md:items-end md:justify-end">
                            {/* Desktop & Tablet Slider */}
                            <div className="relative mt-10 hidden h-[210px] w-[580px] overflow-hidden rounded-lg shadow-lg md:block lg:h-[280px] lg:w-[850px] xl:h-[330px] xl:w-[920px]">
                                <Swiper
                                    modules={[Autoplay]}
                                    slidesPerView={4}
                                    spaceBetween={12}
                                    loop
                                    autoplay={{ delay: 2500, disableOnInteraction: false, pauseOnMouseEnter: true }}
                                    breakpoints={{ 768: { slidesPerView: 3 }, 1024: { slidesPerView: 4 } }}
                                    className="h-full"
                                >
                                    <SwiperSlide><div className="relative h-full w-full"><img src={slide1} alt={t('slider.sigiriya')} className="h-full w-full rounded-[5px] object-cover" /><h4 className="absolute bottom-5 left-5 max-w-[150px] font-medium text-white text-lg lg:text-xl">{t('slider.sigiriya')}</h4></div></SwiperSlide>
                                    <SwiperSlide><div className="relative h-full w-full"><img src={slide2} alt={t('slider.yala')} className="h-full w-full rounded-[5px] object-cover" /><h4 className="absolute bottom-5 left-5 max-w-[150px] font-medium text-white text-lg lg:text-xl">{t('slider.yala')}</h4></div></SwiperSlide>
                                    <SwiperSlide><div className="relative h-full w-full"><img src={slide3} alt={t('slider.tea')} className="h-full w-full rounded-[5px] object-cover" /><h4 className="absolute bottom-5 left-5 max-w-[150px] font-medium text-white text-lg lg:text-xl">{t('slider.tea')}</h4></div></SwiperSlide>
                                    <SwiperSlide><div className="relative h-full w-full"><img src={slide4} alt={t('slider.beaches')} className="h-full w-full rounded-[5px] object-cover" /><h4 className="absolute bottom-5 left-5 max-w-[150px] font-medium text-white text-lg lg:text-xl">{t('slider.beaches')}</h4></div></SwiperSlide>
                                    <SwiperSlide><div className="relative h-full w-full"><img src={slide5} alt={t('slider.temples')} className="h-full w-full rounded-[5px] object-cover" /><h4 className="absolute bottom-5 left-5 max-w-[150px] font-medium text-white text-lg lg:text-xl">{t('slider.temples')}</h4></div></SwiperSlide>
                                </Swiper>
                            </div>

                            {/* Mobile Slider */}
                            <div className="relative mt-10 h-[280px] w-full overflow-hidden rounded-lg shadow-lg md:hidden">
                                <Swiper modules={[Autoplay]} slidesPerView={2} spaceBetween={12} loop autoplay={{ delay: 2500 }}>
                                    <SwiperSlide><div className="relative h-full w-full"><img src={slide1} alt={t('slider.sigiriya')} className="h-full w-full rounded-[5px] object-cover" /><h4 className="absolute bottom-3 left-5 font-medium text-white text-xl">{t('slider.sigiriya')}</h4></div></SwiperSlide>
                                    <SwiperSlide><div className="relative h-full w-full"><img src={slide2} alt={t('slider.yala')} className="h-full w-full rounded-[5px] object-cover" /><h4 className="absolute bottom-3 left-5 font-medium text-white text-xl">{t('slider.yala')}</h4></div></SwiperSlide>
                                    <SwiperSlide><div className="relative h-full w-full"><img src={slide3} alt={t('slider.tea')} className="h-full w-full rounded-[5px] object-cover" /><h4 className="absolute bottom-3 left-5 font-medium text-white text-xl">{t('slider.tea')}</h4></div></SwiperSlide>
                                    <SwiperSlide><div className="relative h-full w-full"><img src={slide4} alt={t('slider.beaches')} className="h-full w-full rounded-[5px] object-cover" /><h4 className="absolute bottom-3 left-5 font-medium text-white text-xl">{t('slider.beaches')}</h4></div></SwiperSlide>
                                    <SwiperSlide><div className="relative h-full w-full"><img src={slide5} alt={t('slider.temples')} className="h-full w-full rounded-[5px] object-cover" /><h4 className="absolute bottom-3 left-5 font-medium text-white text-xl">{t('slider.temples')}</h4></div></SwiperSlide>
                                </Swiper>
                            </div>

                            {/* Hero Texts */}
                            <div className="relative z-10 hidden w-[210px] text-right md:block lg:w-[334px]">
                                <p className="mt-8 text-white text-sm font-medium lg:text-base xl:mt-10">{t('hero.tagline1')}</p>
                                <div className="absolute -bottom-3 right-0 h-1 w-[100px] bg-[#0074D9] lg:w-[150px]"></div>
                            </div>

                            <div className="relative bottom-7 left-0 z-10 mt-14 w-[244px] text-left md:absolute md:mt-10 md:w-[205px] lg:bottom-28 lg:w-[320px] xl:w-[353px]">
                                <p className="text-white text-xs leading-5 font-medium md:text-sm md:leading-normal lg:text-base">{t('hero.tagline2')}</p>
                                <div className="absolute -bottom-3 left-0 h-1 w-[100px] bg-[#7FDBFF] lg:w-[150px]"></div>
                            </div>

                            <div className="relative z-10 flex w-full items-end justify-end text-right md:hidden lg:w-[334px]">
                                <p className="mt-8 w-[220px] text-white text-xs leading-5 font-medium lg:text-base xl:mt-10">{t('hero.tagline1')}</p>
                                <div className="absolute -bottom-3 right-0 h-1 w-[100px] bg-[#0074D9] lg:w-[150px]"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </motion.section>

            {/* ===== ABOUT AAMY TOURS SECTION (Updated - Modern Card + Overlap Style) ===== */}
            <motion.section
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.25 }}
                variants={sectionVariants}
                className="bg-gradient-to-b from-[#001F3F] to-[#000C1F] py-16 md:py-20 lg:py-24 overflow-hidden"
            >
                <div className="container mx-auto px-5 md:px-8 lg:px-12">
                    {/* Header */}
                    <div className="text-center mb-14 md:mb-16">
                        <h2 className="font-konkhmer text-4xl md:text-5xl lg:text-6xl font-bold uppercase tracking-tight text-[#7FDBFF] drop-shadow-md">
                            {t('about.title')}
                        </h2>
                        <div className="mt-4 h-1.5 w-24 md:w-32 lg:w-40 mx-auto bg-gradient-to-r from-[#0074D9] to-[#7FDBFF] rounded-full"></div>
                    </div>

                    {/* Main content - grid layout with featured signature + tour highlights */}
                    <div className="relative">
                        {/* Decorative background elements */}
                        <div className="absolute inset-0 opacity-10 pointer-events-none">
                            <div className="absolute -left-20 -top-20 w-96 h-96 bg-[#0074D9] rounded-full blur-3xl"></div>
                            <div className="absolute -right-20 bottom-10 w-80 h-80 bg-[#7FDBFF] rounded-full blur-3xl"></div>
                        </div>

                        <div className="relative z-10 max-w-6xl mx-auto">
                            {/* Signature title + underline */}
                            <div className="text-center mb-10 md:mb-12">


                            </div>

                            {/* Tour Highlights - Responsive grid with overlap/hover effect cards */}
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 lg:gap-10">
                                {/* Card 1 */}
                                <motion.div
                                    whileHover={{ y: -12, scale: 1.04 }}
                                    transition={{ type: "spring", stiffness: 300, damping: 20 }}
                                    className="group relative bg-gradient-to-br from-[#002b55] to-[#00162f] rounded-2xl overflow-hidden shadow-2xl border border-[#0074D9]/30 hover:border-[#7FDBFF]/60 transition-all duration-400"
                                >
                                    <div className="h-64 md:h-72 overflow-hidden">
                                        <img
                                            src={tourImage1}
                                            alt="Colombo - Classic Sri Lanka"
                                            className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                                        />
                                    </div>
                                    <div className="p-6 md:p-7">
                                        <h4 className="text-[#7FDBFF] text-xl md:text-2xl font-bold mb-2">
                                            {t('tours.classic')}
                                        </h4>
                                        <p className="text-[#7FDBFF]/90 font-semibold mb-3">{t('tours.days4')}</p>
                                        <p className="text-white/80 text-sm md:text-base leading-relaxed">
                                            {t('tours.desc1')}
                                        </p>
                                    </div>
                                </motion.div>

                                {/* Card 2 */}
                                <motion.div
                                    whileHover={{ y: -12, scale: 1.04 }}
                                    transition={{ type: "spring", stiffness: 300, damping: 20 }}
                                    className="group relative bg-gradient-to-br from-[#002b55] to-[#00162f] rounded-2xl overflow-hidden shadow-2xl border border-[#0074D9]/30 hover:border-[#7FDBFF]/60 transition-all duration-400 lg:mt-10"
                                >
                                    <div className="h-64 md:h-72 overflow-hidden">
                                        <img
                                            src={tourImage4}
                                            alt="Yala - Wildlife Safari"
                                            className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                                        />
                                    </div>
                                    <div className="p-6 md:p-7">
                                        <h4 className="text-[#7FDBFF] text-xl md:text-2xl font-bold mb-2">
                                            {t('tours.safari')}
                                        </h4>
                                        <p className="text-[#7FDBFF]/90 font-semibold mb-3">{t('tours.days5')}</p>
                                        <p className="text-white/80 text-sm md:text-base leading-relaxed">
                                            {t('tours.desc2')}
                                        </p>
                                    </div>
                                </motion.div>

                                {/* Card 3 */}
                                <motion.div
                                    whileHover={{ y: -12, scale: 1.04 }}
                                    transition={{ type: "spring", stiffness: 300, damping: 20 }}
                                    className="group relative bg-gradient-to-br from-[#002b55] to-[#00162f] rounded-2xl overflow-hidden shadow-2xl border border-[#0074D9]/30 hover:border-[#7FDBFF]/60 transition-all duration-400 lg:mt-20"
                                >
                                    <div className="h-64 md:h-72 overflow-hidden">
                                        <img
                                            src={tourImage5}
                                            alt="Ella / Nuwara Eliya - Hill Country Retreat"
                                            className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                                        />
                                    </div>
                                    <div className="p-6 md:p-7">
                                        <h4 className="text-[#7FDBFF] text-xl md:text-2xl font-bold mb-2">
                                            {t('tours.retreat')}
                                        </h4>
                                        <p className="text-[#7FDBFF]/90 font-semibold mb-3">{t('tours.days6')}</p>
                                        <p className="text-white/80 text-sm md:text-base leading-relaxed">
                                            {t('tours.desc3')}
                                        </p>
                                    </div>
                                </motion.div>
                            </div>

                            {/* Optional extra images floating subtly (decorative) */}
                            <div className="hidden lg:block absolute -left-16 top-32 w-44 h-44 rounded-2xl overflow-hidden border-4 border-[#0074D9]/40 shadow-xl rotate-[-8deg] z-0">
                                <img src={tourImage2} alt="" className="w-full h-full object-cover" />
                            </div>
                            <div className="hidden lg:block absolute -right-20 bottom-40 w-52 h-52 rounded-2xl overflow-hidden border-4 border-[#7FDBFF]/30 shadow-xl rotate-[6deg] z-0">
                                <img src={tourImage6} alt="" className="w-full h-full object-cover" />
                            </div>
                        </div>
                    </div>
                </div>
            </motion.section>

            {/* ===== WHO WE ARE ===== */}
            <motion.section initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={sectionVariants} className="bg-[#001F3F] py-10">
                <div className="container mx-auto px-4">
                    {/* Desktop */}
                    <div className="hidden md:grid md:grid-cols-4 gap-8 ">
                        <div className="relative text-center"><span className="absolute -top-24 left-1/2 -translate-x-1/2 text-[6.25rem] font-bold text-[#7FDBFF] opacity-90"></span><div className="border border-[#0074D9] bg-[#001F3F]/80 p-6"><h3 className="text-2xl font-semibold text-[#7FDBFF]">{t('whoWeAre.item1.title')}</h3><p className="mt-4 text-xl">{t('whoWeAre.item1.text')}</p></div></div>
                        <div className="relative text-center"><span className="absolute -top-24 left-1/2 -translate-x-1/2 text-[6.25rem] font-bold text-[#7FDBFF] opacity-90"></span><div className="border border-[#0074D9] bg-[#001F3F]/80 p-6"><h3 className="text-2xl font-semibold text-[#7FDBFF]">{t('whoWeAre.item2.title')}</h3><p className="mt-4 text-xl">{t('whoWeAre.item2.text')}</p></div></div>
                        <div className="relative text-center"><span className="absolute -top-24 left-1/2 -translate-x-1/2 text-[6.25rem] font-bold text-[#7FDBFF] opacity-90"></span><div className="border border-[#0074D9] bg-[#001F3F]/80 p-6"><h3 className="text-2xl font-semibold text-[#7FDBFF]">{t('whoWeAre.item3.title')}</h3><p className="mt-4 text-xl">{t('whoWeAre.item3.text')}</p></div></div>
                        <div className="relative text-center"><span className="absolute -top-24 left-1/2 -translate-x-1/2 text-[6.25rem] font-bold text-[#7FDBFF] opacity-90"></span><div className="border border-[#0074D9] bg-[#001F3F]/80 p-6"><h3 className="text-2xl font-semibold text-[#7FDBFF]">{t('whoWeAre.item4.title')}</h3><p className="mt-4 text-xl">{t('whoWeAre.item4.text')}</p></div></div>
                    </div>

                    {/* Mobile */}
                    <div className="md:hidden space-y-6">
                        <div className="border border-[#0074D9] bg-[#001F3F]/80 p-6 text-center"><h3 className="text-xl font-semibold text-[#7FDBFF]">{t('whoWeAre.item1.title')}</h3><p className="mt-3">{t('whoWeAre.item1.text')}</p></div>
                        <div className="border border-[#0074D9] bg-[#001F3F]/80 p-6 text-center"><h3 className="text-xl font-semibold text-[#7FDBFF]">{t('whoWeAre.item2.title')}</h3><p className="mt-3">{t('whoWeAre.item2.text')}</p></div>
                        <div className="border border-[#0074D9] bg-[#001F3F]/80 p-6 text-center"><h3 className="text-xl font-semibold text-[#7FDBFF]">{t('whoWeAre.item3.title')}</h3><p className="mt-3">{t('whoWeAre.item3.text')}</p></div>
                        <div className="border border-[#0074D9] bg-[#001F3F]/80 p-6 text-center"><h3 className="text-xl font-semibold text-[#7FDBFF]">{t('whoWeAre.item4.title')}</h3><p className="mt-3">{t('whoWeAre.item4.text')}</p></div>
                    </div>

                    <div className="mt-16 flex flex-col md:flex-row items-start justify-between gap-10">
                        <div className="md:w-[38%] md:mt-20">
                            <h2 className="font-konkhmer text-4xl font-semibold lg:text-6xl text-[#7FDBFF]">{t('whoWeAre.title')}</h2>
                            <p className="mt-7 text-sm md:text-base lg:text-lg leading-8 text-white/80" dangerouslySetInnerHTML={{ __html: t('whoWeAre.description') }} />
                        </div>
                        <img src={aboutImage} alt={t('whoWeAre.imageAlt')} className="w-full md:w-[45%] rounded-[20px] object-cover h-[450px] md:h-[687px]" />
                    </div>
                </div>
            </motion.section>

            {/* ===== WHAT WE OFFER ===== */}
            <motion.section initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={sectionVariants} className="bg-[#001F3F] py-10">
                <div className="container mx-auto px-4 text-center">
                    <h2 className="font-konkhmer text-4xl font-bold uppercase md:text-5xl lg:text-6xl text-[#7FDBFF]">

                        {t('offers.title')}

                    </h2>


                    <div className="mt-12 flex overflow-x-auto gap-4 pb-5 md:grid md:grid-cols-4 md:pb-0">
                        <div className="relative shrink-0 w-[330px] md:w-auto"><img src={offer1} alt={t('offers.cultural.alt')} className="h-[620px] md:h-[650px] w-full object-cover rounded-[15px]" /><div className="absolute bottom-0 w-full bg-gradient-to-t from-black/80 to-transparent p-6"><h4 className="text-2xl font-bold">{t('offers.cultural.title')}</h4><p className="mt-3 text-lg">{t('offers.cultural.text')}</p></div></div>
                        <div className="relative shrink-0 w-[330px] md:w-auto"><img src={offer2} alt={t('offers.adventure.alt')} className="h-[620px] md:h-[650px] w-full object-cover rounded-[15px]" /><div className="absolute bottom-0 w-full bg-gradient-to-t from-black/80 to-transparent p-6"><h4 className="text-2xl font-bold">{t('offers.adventure.title')}</h4><p className="mt-3 text-lg">{t('offers.adventure.text')}</p></div></div>
                        <div className="relative shrink-0 w-[330px] md:w-auto"><img src={offer3} alt={t('offers.luxury.alt')} className="h-[620px] md:h-[650px] w-full object-cover rounded-[15px]" /><div className="absolute bottom-0 w-full bg-gradient-to-t from-black/80 to-transparent p-6"><h4 className="text-2xl font-bold">{t('offers.luxury.title')}</h4><p className="mt-3 text-lg">{t('offers.luxury.text')}</p></div></div>
                        <div className="relative shrink-0 w-[330px] md:w-auto"><img src={offer4} alt={t('offers.wellness.alt')} className="h-[620px] md:h-[650px] w-full object-cover rounded-[15px]" /><div className="absolute bottom-0 w-full bg-gradient-to-t from-black/80 to-transparent p-6"><h4 className="text-2xl font-bold">{t('offers.wellness.title')}</h4><p className="mt-3 text-lg">{t('offers.wellness.text')}</p></div></div>
                    </div>
                </div>
            </motion.section>



            {/* ===== TOUR EXPERT ===== */}
            <motion.section initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={sectionVariants} className="relative bg-gradient-to-br from-[#001F3F] via-[#000C1F] to-[#001F3F] py-16 md:py-20 lg:py-28 xl:py-32 overflow-hidden">
                {/* Decorative background elements */}
                <div className="absolute inset-0 opacity-20 pointer-events-none">
                    <div className="absolute -left-40 top-1/4 w-96 h-96 bg-[#0074D9] rounded-full blur-3xl"></div>
                    <div className="absolute -right-40 bottom-1/4 w-96 h-96 bg-[#7FDBFF] rounded-full blur-3xl"></div>
                </div>

                <div className="container mx-auto px-4 lg:px-8">
                    <div className="relative z-10 flex flex-col-reverse md:flex-row items-center justify-between gap-12 md:gap-16 lg:gap-20">
                        {/* Image Section */}
                        <motion.div
                            whileHover={{ scale: 1.05 }}
                            transition={{ type: "spring", stiffness: 300 }}
                            className="w-full md:w-1/2"
                        >
                            <div className="relative group">
                                <div className="absolute -inset-1 bg-gradient-to-r from-[#0074D9] to-[#7FDBFF] rounded-[30px] opacity-0 group-hover:opacity-100 blur-xl transition duration-500"></div>
                                <img
                                    src={tourExpert}
                                    alt={t('expert.imageAlt')}
                                    className="relative w-full rounded-[30px] shadow-2xl object-cover h-[400px] md:h-[500px] lg:h-[650px] xl:h-[750px] border-2 border-[#0074D9]/50 group-hover:border-[#7FDBFF] transition duration-500"
                                />
                            </div>
                        </motion.div>

                        {/* Text Section */}
                        <motion.div
                            initial={{ opacity: 0, x: 50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.8 }}
                            className="w-full md:w-1/2 text-center md:text-right"
                        >
                            <div className="space-y-6 md:space-y-8 lg:space-y-10">
                                {/* Name */}
                                <div>
                                    <h3 className="font-konkhmer text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold bg-gradient-to-r from-[#7FDBFF] to-[#0074D9] bg-clip-text text-transparent drop-shadow-lg">
                                        {t('expert.name')}
                                    </h3>
                                </div>

                                {/* Role */}
                                <div>
                                    <h4 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold uppercase tracking-wider text-[#7FDBFF]">
                                        {t('expert.role')}
                                    </h4>
                                </div>

                                {/* Decorative lines */}
                                <div className="flex flex-col gap-3 md:flex-row md:justify-end md:gap-4">
                                    <div className="h-1.5 w-32 bg-gradient-to-r from-[#7FDBFF] to-[#0074D9] rounded-full mx-auto md:mx-0"></div>
                                    <div className="h-1.5 w-24 bg-gradient-to-r from-[#0074D9] to-[#7FDBFF] rounded-full mx-auto md:mx-0"></div>
                                </div>

                                {/* Bio */}
                                <div>
                                    <p
                                        className="text-base md:text-lg lg:text-xl xl:text-2xl leading-relaxed md:leading-loose text-white/85 font-light tracking-wide"
                                        dangerouslySetInnerHTML={{ __html: t('expert.bio') }}
                                    />
                                </div>

                                {/* Accent badge */}
                                <div className="flex justify-center md:justify-end pt-4">
                                    <div className="inline-block px-6 md:px-8 py-3 md:py-4 rounded-full border-2 border-[#0074D9] bg-[#001F3F]/50 backdrop-blur-sm hover:border-[#7FDBFF] transition duration-300">
                                        <p className="text-sm md:text-base lg:text-lg font-semibold text-[#7FDBFF]">Expert Guide & Travel Consultant</p>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </div>
            </motion.section>

            {/* ===== AROUND VILLAGE TOURS ===== */}
            <motion.section initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={sectionVariants} className="relative bg-gradient-to-br from-[#001F3F] via-[#000C1F] to-[#001F3F] py-16 md:py-20 lg:py-28 xl:py-32 overflow-hidden">
                {/* Decorative background elements */}
                <div className="absolute inset-0 opacity-20 pointer-events-none">
                    <div className="absolute -right-40 top-1/4 w-96 h-96 bg-[#7FDBFF] rounded-full blur-3xl"></div>
                    <div className="absolute -left-40 bottom-1/4 w-96 h-96 bg-[#0074D9] rounded-full blur-3xl"></div>
                </div>

                <div className="container mx-auto px-4 lg:px-8">
                    <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-12 md:gap-16 lg:gap-20">
                        {/* Text Section - Left Side */}
                        <motion.div
                            initial={{ opacity: 0, x: -50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.8 }}
                            className="w-full md:w-1/2 text-center md:text-left"
                        >
                            <div className="space-y-6 md:space-y-8 lg:space-y-10">
                                {/* Title */}
                                <div>
                                    <h2 className="font-konkhmer text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold bg-gradient-to-r from-[#0074D9] to-[#7FDBFF] bg-clip-text text-transparent drop-shadow-lg">
                                        {t('villageTours.title')}
                                    </h2>
                                </div>

                                {/* Decorative lines */}
                                <div className="flex flex-col gap-3 md:flex-row md:gap-4">
                                    <div className="h-1.5 w-32 bg-gradient-to-r from-[#0074D9] to-[#7FDBFF] rounded-full mx-auto md:mx-0"></div>
                                    <div className="h-1.5 w-24 bg-gradient-to-r from-[#7FDBFF] to-[#0074D9] rounded-full mx-auto md:mx-0"></div>
                                </div>

                                {/* Description */}
                                <div>
                                    <p className="text-base md:text-lg lg:text-xl xl:text-2xl leading-relaxed md:leading-loose text-white/85 font-light tracking-wide">
                                        {t('villageTours.description')}
                                    </p>
                                </div>

                                {/* Book Button */}
                                <div className="pt-4">
                                    <button
                                        onClick={() => window.open('https://wa.me/94767584594?text=Hello%20Sonic%20Tours!%20I%20am%20interested%20in%20booking%20the%20Around%20Village%20Tours%20in%20Moragalla,%20Beruwala.%20Please%20provide%20more%20details.', '_blank')}
                                        className="rounded-full bg-gradient-to-r from-[#0074D9] to-[#7FDBFF] px-8 py-4 font-bold text-white hover:opacity-90 transition-opacity duration-300"
                                    >
                                        {t('villageTours.bookButton')}
                                    </button>
                                </div>

                            </div>
                        </motion.div>

                        {/* Image Section - Right Side */}
                        <motion.div
                            whileHover={{ scale: 1.05 }}
                            transition={{ type: "spring", stiffness: 300 }}
                            className="w-full md:w-1/2"
                        >
                            <div className="relative group">
                                <div className="absolute -inset-1 bg-gradient-to-r from-[#7FDBFF] to-[#0074D9] rounded-[30px] opacity-0 group-hover:opacity-100 blur-xl transition duration-500"></div>
                                <img
                                    src={villageImage}
                                    alt={t('villageTours.imageAlt')}
                                    className="relative w-full rounded-[30px] shadow-2xl object-cover h-[400px] md:h-[500px] lg:h-[650px] xl:h-[750px] border-2 border-[#7FDBFF]/50 group-hover:border-[#0074D9] transition duration-500"
                                />
                            </div>
                        </motion.div>
                    </div>
                </div>
            </motion.section>

            {/* ===== VEHICLES ===== */}
            <section initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={sectionVariants} className="bg-[#001F3F] py-10">
                <div className="container mx-auto px-4 flex flex-col md:flex-row gap-10">
                    <div className="md:w-1/3">
                        <h2 className="font-konkhmer text-4xl lg:text-5xl font-semibold leading-tight text-[#7FDBFF]">{t('vehicles.title')}</h2>
                        <p className="mt-5 text-lg text-white/80" dangerouslySetInnerHTML={{ __html: t('vehicles.text') }} />
                        <button
                            onClick={() => window.open('https://wa.me/94768539635?text=Hello%20Aamy%20Tours!%20I%20want%20to%20book%20a%20tour.', '_blank')}
                            className="mt-6 rounded-full bg-gradient-to-r from-[#0074D9] to-[#7FDBFF] px-8 py-4 font-bold text-white hover:opacity-90"
                        >
                            {t('vehicles.bookButton')}
                        </button>
                    </div>

                    <div className="md:w-2/3">
                        {/* Desktop Slider */}
                        <div className="hidden md:block">
                            <Swiper modules={[Autoplay]} slidesPerView={2.5} spaceBetween={20} loop autoplay={{ delay: 3000 }} className="pb-10">
                                <SwiperSlide>
                                    <div className="relative bg-white text-black rounded-[20px] overflow-hidden">
                                        <div className="bg-[#0074D9] text-white py-4 text-center text-2xl font-bold">{t('vehicles.car.title')}</div>
                                        <img src={car} alt="Car" className="w-full h-96 object-cover" />
                                        <div className="p-6 flex justify-between items-center">
                                            <p>{t('vehicles.car.text')}</p>
                                            <img src={arrow} alt="Arrow" className="w-16" />
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="relative bg-white text-black rounded-[20px] overflow-hidden">
                                        <div className="bg-[#0074D9] text-white py-4 text-center text-2xl font-bold">{t('vehicles.van.title')}</div>
                                        <img src={van} alt="Van" className="w-full h-96 object-cover" />
                                        <div className="p-6 flex justify-between items-center">
                                            <p>{t('vehicles.van.text')}</p>
                                            <img src={arrow} alt="Arrow" className="w-16" />
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="relative bg-white text-black rounded-[20px] overflow-hidden">
                                        <div className="bg-[#0074D9] text-white py-4 text-center text-2xl font-bold">{t('vehicles.minibus.title')}</div>
                                        <img src={minibus} alt="Minibus" className="w-full h-96 object-cover" />
                                        <div className="p-6 flex justify-between items-center">
                                            <p>{t('vehicles.minibus.text')}</p>
                                            <img src={arrow} alt="Arrow" className="w-16" />
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="relative bg-white text-black rounded-[20px] overflow-hidden">
                                        <div className="bg-[#0074D9] text-white py-4 text-center text-2xl font-bold">{t('vehicles.luxury.title')}</div>
                                        <img src={luxury} alt="Luxury" className="w-full h-96 object-cover" />
                                        <div className="p-6 flex justify-between items-center">
                                            <p>{t('vehicles.luxury.text')}</p>
                                            <img src={arrow} alt="Arrow" className="w-16" />
                                        </div>
                                    </div>
                                </SwiperSlide>
                            </Swiper>
                        </div>

                        {/* Mobile Stacked */}
                        <div className="md:hidden space-y-8">
                            <div className="bg-white text-black rounded-[20px] overflow-hidden">
                                <div className="bg-[#0074D9] text-white py-6 text-center text-3xl font-bold">{t('vehicles.car.title')}</div>
                                <img src={car} alt="Car" className="w-full h-96 object-cover" />
                                <div className="p-6 flex justify-between items-center">
                                    <p>{t('vehicles.car.text')}</p>
                                    <img src={arrow} alt="Arrow" className="w-12" />
                                </div>
                            </div>
                            <div className="bg-white text-black rounded-[20px] overflow-hidden">
                                <div className="bg-[#0074D9] text-white py-6 text-center text-3xl font-bold">{t('vehicles.van.title')}</div>
                                <img src={van} alt="Van" className="w-full h-96 object-cover" />
                                <div className="p-6 flex justify-between items-center">
                                    <p>{t('vehicles.van.text')}</p>
                                    <img src={arrow} alt="Arrow" className="w-12" />
                                </div>
                            </div>
                            <div className="bg-white text-black rounded-[20px] overflow-hidden">
                                <div className="bg-[#0074D9] text-white py-6 text-center text-3xl font-bold">{t('vehicles.minibus.title')}</div>
                                <img src={minibus} alt="Minibus" className="w-full h-96 object-cover" />
                                <div className="p-6 flex justify-between items-center">
                                    <p>{t('vehicles.minibus.text')}</p>
                                    <img src={arrow} alt="Arrow" className="w-12" />
                                </div>
                            </div>
                            <div className="bg-white text-black rounded-[20px] overflow-hidden">
                                <div className="bg-[#0074D9] text-white py-6 text-center text-3xl font-bold">{t('vehicles.luxury.title')}</div>
                                <img src={luxury} alt="Luxury" className="w-full h-96 object-cover" />
                                <div className="p-6 flex justify-between items-center">
                                    <p>{t('vehicles.luxury.text')}</p>
                                    <img src={arrow} alt="Arrow" className="w-12" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



            {/* ===== IMPORTANT NOTICES ===== */}
            <motion.section initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={sectionVariants} className="bg-[#001F3F] py-10">
                <div className="container mx-auto px-4 text-center">
                    <h2 className="font-konkhmer text-4xl font-bold uppercase md:text-5xl lg:text-6xl text-[#7FDBFF]">

                        {t('notices.title')}

                    </h2>


                    <p className="mt-8 max-w-3xl mx-auto text-lg text-white/80">{t('notices.intro')}</p>

                    <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-8 md:max-w-8xl">

                        <div className="group relative overflow-hidden rounded-[20px] bg-gradient-to-br from-[#001F3F] to-[#00162F] shadow-xl">
                            <img src={noticeFruits} alt="Fruits Bag" className="w-full h-80 object-cover group-hover:scale-110 transition" />
                            <div className="p-8">
                                <div className="flex items-center gap-4">
                                    <div className="w-12 h-12 rounded-full bg-gradient-to-r from-[#7FDBFF] to-[#0074D9] flex items-center justify-center text-2xl">🍎</div>
                                    <h3 className="text-2xl font-bold">{t('notices.fruits.title')}</h3>
                                </div>
                                <p className="mt-4 text-white/80">{t('notices.fruits.text')}</p>
                            </div>
                        </div>

                        <div className="group relative overflow-hidden rounded-[20px] bg-gradient-to-br from-[#001F3F] to-[#00162F] shadow-xl">
                            <img src={noticeFood} alt="Free Meals" className="w-full h-80 object-cover group-hover:scale-110 transition" />
                            <div className="p-8">
                                <div className="flex items-center gap-4">
                                    <div className="w-12 h-12 rounded-full bg-gradient-to-r from-[#0074D9] to-[#7FDBFF] flex items-center justify-center text-2xl">🍽️</div>
                                    <h3 className="text-2xl font-bold">{t('notices.meals.title')}</h3>
                                </div>
                                <p className="mt-4 text-white/80">{t('notices.meals.text')}</p>
                            </div>
                        </div>

                        <div className="group relative overflow-hidden rounded-[20px] bg-gradient-to-br from-[#001F3F] to-[#00162F] shadow-xl">
                            <img src={noticeMassage} alt="Free Massage" className="w-full h-80 object-cover group-hover:scale-110 transition" />
                            <div className="p-8">
                                <div className="flex items-center gap-4">
                                    <div className="w-12 h-12 rounded-full bg-gradient-to-r from-[#7FDBFF] to-[#0074D9] flex items-center justify-center text-2xl">💆</div>
                                    <h3 className="text-2xl font-bold">{t('notices.massage.title')}</h3>
                                </div>
                                <p className="mt-4 text-white/80">{t('notices.massage.text')}</p>
                            </div>
                        </div>

                        <div className="group relative overflow-hidden rounded-[20px] bg-gradient-to-br from-[#001F3F] to-[#00162F] shadow-xl">
                            <img src={noticeFlowers} alt="Free Flowers" className="w-full h-80 object-cover group-hover:scale-110 transition" />
                            <div className="p-8">
                                <div className="flex items-center gap-4">
                                    <div className="w-12 h-12 rounded-full bg-gradient-to-r from-[#0074D9] to-[#7FDBFF] flex items-center justify-center text-2xl">🌺</div>
                                    <h3 className="text-2xl font-bold">{t('notices.flowers.title')}</h3>
                                </div>
                                <p className="mt-4 text-white/80">{t('notices.flowers.text')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </motion.section>
        </div>
    );
};

export default About;